import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Please fill out all the required fields with the red asterisk ("),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*"),
  /*#__PURE__*/_createTextVNode(")")
], -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-6 mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t border-gray-200" }, null, -1)
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = ["src", "disabled"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-span-1" }
const _hoisted_10 = { class: "col-span-1" }
const _hoisted_11 = { class: "col-span-2" }
const _hoisted_12 = { class: "col-span-1" }
const _hoisted_13 = { class: "col-span-1" }
const _hoisted_14 = { class: "col-span-1" }
const _hoisted_15 = { class: "col-span-1" }
const _hoisted_16 = { class: "col-span-2" }
const _hoisted_17 = { class: "col-span-2" }
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = { class: "col-span-2" }
const _hoisted_20 = { class: "col-span-2" }

import { ref, onMounted } from 'vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import { numberonly } from "@/components/composables/useNumberOnly";

import { OfficeDataInterface, SelectInterface} from "@/interfaces/pages/offices/OfficeInterface"
import FileInput from "@/components/inputs/FileInput.vue";
import { XMarkIcon, LinkIcon } from "@heroicons/vue/24/outline";
import DropdownService from "@/classes/Dropdowns/DropdownService";
import { hasPermission } from "@/classes/AuthService";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object as () => OfficeDataInterface,
        defualt: [],
        required: true,
    },
    errors: {
        type: Object,
        defualt: [],
        required: true,
    },
},
  emits: ['update:location'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const statusOptions = [
    { id: 0, label: 'Inactive', value: 0},
    { id: 1, label: 'Active', value: 1 }
]

const form = ref<OfficeDataInterface>(props.form);
const regionOptions = ref<SelectInterface>([])
const provinceOptions = ref<SelectInterface>([])
const cityOptions = ref<SelectInterface>([])
const barangayOptions = ref<SelectInterface>([])

const preview = ref<string|null>(null);
const logo = ref<string|null>(null);

const handleImagePreview = (event) => {
  const input = event.target;
  if (input.files) {
    const reader = new FileReader();
    reader.onload = (e) => {
      preview.value = e.target.result;
    };
    logo.value = input.files[0];
    form.value.logo = input.files[0];
    console.log(form.value.logo);
    reader.readAsDataURL(logo.value);
  }
};

const openLink = (): void => {
    if (form.value.logo != '') {
        preview.value = '';
        form.value.logo = '';
    }
}

const getRegions = ():void => {
    DropdownService
        .regions()
        .then(({data}) => {
            regionOptions.value = data;
        })
}

const getProvince = ():void => {
    if(form.value.region_id){
        DropdownService
            .provinces(form.value.region_id)
            .then(({data}) => {
                provinceOptions.value = data;
            })
    }
}

const getCity = ():void => {
    if(form.value.province_id){
        DropdownService
            .cities(form.value.province_id)
            .then(({data}) => {
                cityOptions.value = data;
            })
    }
}

const getBrangay = ():void => {
    if(form.value.city_id){
        DropdownService
            .barangays(form.value.city_id)
            .then(({data}) => {
                barangayOptions.value = data;
            })
    }
}

const regionChange = ():void => {
    form.value.city_id = null
    form.value.barangay_id = null
    form.value.province_id = null
    getProvince()
}

const provinceChange = ():void => {
    form.value.city_id = null
    form.value.barangay_id = null
    getCity()
}

const cityChange = ():void => { 
    form.value.barangay_id = null
    getBrangay()
}

onMounted(() => {
    getRegions()

    if(form.value.id){
        getProvince();
        getCity();
        getBrangay();
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTitle, {
      fontSmall: "",
      title: "Office Information"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("form", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          type: "text",
          label: "Office Name",
          placeholder: "Office name",
          name: "office_name",
          id: "office_name",
          modelValue: form.value.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
          error: __props.errors?.name,
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(FileInput, {
          id: "office_logo",
          name: "office_logo",
          label: "Office Logo",
          trailingIcon: form.value.logo ? _unref(XMarkIcon) : _unref(LinkIcon),
          trailingIconClass: form.value.logo ? 'pointer-events-auto' : 'pointer-events-none',
          onChange: handleImagePreview,
          onIconClick: _cache[1] || (_cache[1] = ($event: any) => (openLink())),
          error: __props.errors?.logo,
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["trailingIcon", "trailingIconClass", "error", "disabled"]),
        (preview.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "mt-2 max-h-[300px] border border-gray-200 rounded p-2",
              src: preview.value,
              alt: "Image Preview",
              disabled: !_unref(hasPermission)('can-update-department')
            }, null, 8, _hoisted_7))
          : (!preview.value && form.value.file_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "mt-2 max-h-[300px] border border-gray-200 rounded p-2",
                src: form.value.file_url,
                alt: "Image Preview"
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(TextInput, {
          type: "text",
          label: "Prefix",
          placeholder: "Prefix",
          name: "prefix",
          id: "prefix",
          modelValue: form.value.prefix,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.prefix) = $event)),
          error: __props.errors?.prefix,
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(TextInput, {
          type: "tel",
          label: "Contact Number",
          placeholder: "contact number",
          name: "contact_number",
          id: "contact_number",
          add_on_left: true,
          add_on_text: "+63",
          maxlength: 10,
          modelValue: form.value.contact_number,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.contact_number) = $event)),
          error: __props.errors?.contact_number,
          onKeypress: _unref(numberonly),
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "onKeypress", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(TextInput, {
          type: "text",
          label: "Address",
          placeholder: "address",
          name: "address",
          id: "address",
          modelValue: form.value.address,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.address) = $event)),
          error: __props.errors?.address,
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: regionOptions.value,
          id: "region",
          name: "region",
          label: "Region",
          placeholder: "Select..",
          modelValue: form.value.region_id,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((form.value.region_id) = $event)),
            _cache[6] || (_cache[6] = ($event: any) => (regionChange()))
          ],
          error: __props.errors?.region_id,
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["options", "modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: provinceOptions.value,
          id: "province",
          name: "province",
          label: "Province",
          placeholder: "Select..",
          modelValue: form.value.province_id,
          "onUpdate:modelValue": [
            _cache[7] || (_cache[7] = ($event: any) => ((form.value.province_id) = $event)),
            _cache[8] || (_cache[8] = ($event: any) => (provinceChange()))
          ],
          error: __props.errors?.province_id,
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["options", "modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: cityOptions.value,
          id: "city_municipality",
          name: "city_municipality",
          label: "City/Municipality/District",
          placeholder: "Select..",
          modelValue: form.value.city_id,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((form.value.city_id) = $event)),
            _cache[10] || (_cache[10] = ($event: any) => (cityChange()))
          ],
          error: __props.errors?.city_id,
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["options", "modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: barangayOptions.value,
          id: "barangay",
          name: "barangay",
          label: "Barangay",
          placeholder: "Select..",
          modelValue: form.value.barangay_id,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.barangay_id) = $event)),
          error: __props.errors?.barangay_id,
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["options", "modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: statusOptions,
          id: "status",
          name: "status",
          label: "Status",
          placeholder: "Select..",
          modelValue: form.value.status,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.status) = $event)),
          error: __props.errors?.status,
          required: "",
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(TextInput, {
          type: "text",
          label: "ISO For Intake PDF Form",
          placeholder: "Intake ISO",
          name: "iso_intake",
          id: "iso_intake",
          modelValue: form.value.iso_intake,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.iso_intake) = $event)),
          error: __props.errors?.iso_intake,
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(TextInput, {
          type: "text",
          label: "ISO For Patient Profile PDF Form",
          placeholder: "Patient Profile ISO",
          name: "iso_patient_profile",
          id: "iso_patient_profile",
          modelValue: form.value.iso_patient_profile,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.iso_patient_profile) = $event)),
          error: __props.errors?.iso_patient_profile,
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(TextInput, {
          type: "text",
          label: "ISO For Safety Assessment PDF Form",
          placeholder: "Safety Assessment ISO",
          name: "iso_assessment",
          id: "iso_assessment",
          modelValue: form.value.iso_assessment,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.iso_assessment) = $event)),
          error: __props.errors?.iso_assessment,
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(TextInput, {
          type: "text",
          label: "ISO For SCAR PDF Form",
          placeholder: "SCAR ISO",
          name: "iso_scar",
          id: "iso_scar",
          modelValue: form.value.iso_scar,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.iso_scar) = $event)),
          error: __props.errors?.iso_scar,
          disabled: !_unref(hasPermission)('can-update-department')
        }, null, 8, ["modelValue", "error", "disabled"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})